module.exports = __webpack_public_path__ + "static/media/gold.c79a9e7f.png";